import React, { useEffect, useState } from "react";
import { Phone, MessageCircle } from "lucide-react";
import { COLLEGE } from "../data/college";
import { useT } from "../i18n/LanguageProvider";

const StickyCall = () => {
  const { t } = useT();
  const [show, setShow] = useState(false);
  const waUrl = `https://wa.me/91${COLLEGE.phone_primary}?text=${encodeURIComponent(
    COLLEGE.whatsapp_message
  )}`;

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed z-[60] bottom-5 left-5 md:bottom-7 md:left-7 flex flex-col items-start gap-3 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      {/* WhatsApp */}
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-sticky-whatsapp-btn"
        className="relative group"
        aria-label="WhatsApp chat"
      >
        <span className="absolute inset-0 rounded-full bg-[#39FF14] animate-ping opacity-20" />
        <span className="relative flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#39FF14] text-[#04060a] shadow-[0_0_24px_rgba(57,255,20,0.5)] hover:scale-110 transition-transform">
          <MessageCircle className="w-6 h-6" strokeWidth={2.6} />
        </span>
      </a>

      {/* Call */}
      <a
        href={`tel:+91${COLLEGE.phone_primary}`}
        data-testid="mobile-sticky-call-btn"
        className="relative group"
      >
        <span className="absolute inset-0 rounded-full bg-[#00E5FF] animate-ping opacity-25" />
        <span className="relative flex items-center gap-2.5 px-5 py-3.5 md:px-6 md:py-4 rounded-full bg-gradient-to-br from-[#00E5FF] to-[#39FF14] text-[#04060a] font-heading font-bold text-sm md:text-base uppercase tracking-wider shadow-[0_0_30px_rgba(0,229,255,0.5)] hover:scale-105 transition-transform">
          <Phone className="w-5 h-5" strokeWidth={2.8} />
          {t("btn.callNow")}
        </span>
      </a>
    </div>
  );
};

export default StickyCall;
